import { render } from "./LabeledTextArea.vue?vue&type=template&id=0666eae6"
import script from "./LabeledTextArea.vue?vue&type=script&lang=js"
export * from "./LabeledTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__